import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import StorageUnitDTO from '../../DTOs/StorageUnit/StorageUnitDTO';
import MobileCard from './MobileCard';
import { USDollar } from '../../utilities/Constants';
import { trimDate } from '../../utilities/DateFormat';

export default function StorageUnitMaintenanceCardMobile(props) {
    const { storageUnit, showEditModal, showDeleteModal } = props;

    const currentUser = storageUnit.currentUser
        ? `${storageUnit.currentUser.firstName} ${storageUnit.currentUser.lastName}`
        : null;

    return (
        <MobileCard
            title={`Unit ${storageUnit.name}`}
            subtitle={`${storageUnit.facility.name} \u2013 ${storageUnit.section.name}`}
            status={storageUnit.hold ? { label: 'On hold', color: 'warning' } : undefined}
            fields={[
                { label: 'Tenant', value: currentUser },
                { label: 'Email', value: storageUnit.currentUser?.username ?? null },
                { label: 'Size', value: storageUnit.storageSize },
                { label: 'Type', value: storageUnit.storageUnitType.name },
                { label: 'Climate', value: storageUnit.climateControlled ? 'Controlled' : 'Not controlled' },
                { label: 'Price', value: USDollar.format(storageUnit.price) },
                { label: 'Cancelled', value: trimDate(storageUnit.nextReadyDate) },
            ]}
            actions={
                <>
                    <Button variant={'contained'} onClick={showEditModal}>Edit</Button>
                    <Button variant={'outlined'} color={'error'} onClick={showDeleteModal}>Delete</Button>
                </>
            }
        />
    );
}

StorageUnitMaintenanceCardMobile.propTypes = {
    storageUnit: PropTypes.objectOf(StorageUnitDTO),
    showEditModal: PropTypes.func,
    showDeleteModal: PropTypes.func,
};
